import axios from 'axios'

const axios_intents = axios.create()

export default axios_intents